<div class="splash-screen">
  @if (!error()) {
    <div class="reveal">
      <div class="image-container">
        <i nz-icon nzType="icons:loading" class="svg-icon fillwhite"></i>
      </div>
    </div>
  }
</div>

@if (error()) {
  <section class="splash-screen">
    <div class="container">
      <div class="error-image-container">
        <img src="assets/images/splash.png" alt="Error image" />
      </div>
      <div class="error-wrapper">
        <div class="content-main">
          {{ i18n.langString("connection_error") }}
        </div>
        <div class="error-container">
          <app-nav-button
            [primary]="true"
            svgIcon="icons:reset"
            [href]="refreshPage"
          >
            {{ i18n.langString("network_issue") }}
          </app-nav-button>
        </div>
      </div>
    </div>
  </section>
}
